import React from "react";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { Footer } from "../../../components/Footer";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";

export const Dashboard = () => {
    return (
        <section>
            <Header />
            <main className="d-flex">
                <Menu></Menu>
                <StyledDefaultPage>
                    <p>Olá</p>
                </StyledDefaultPage>
            </main>

        </section>
    );
};
